"use strict";

exports.__esModule = true;

exports.default = function () {};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/babel-register/lib/browser.js
// module id = 203
// module chunks = 0